import { render, staticRenderFns } from "./DropboxSelector.vue?vue&type=template&id=71c12754&"
import script from "./DropboxSelector.vue?vue&type=script&lang=js&"
export * from "./DropboxSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports